import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  loginDataUpdated: EventEmitter<any> = new EventEmitter();

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  setLoginData(data: any) {
    if (isPlatformBrowser(this.platformId)) { 
      localStorage.setItem('loginData', JSON.stringify(data));
      this.loginDataUpdated.emit(data);
    }
  }

  getLoginData() {
    if (isPlatformBrowser(this.platformId)) { 
      const data = localStorage.getItem('loginData');
      return data ? JSON.parse(data) : null;
    }
    return null;
  }

}
